import { render, staticRenderFns } from "./Netlink.vue?vue&type=template&id=7036b02c&scoped=true"
import script from "./Netlink.vue?vue&type=script&lang=js"
export * from "./Netlink.vue?vue&type=script&lang=js"
import style0 from "./Netlink.vue?vue&type=style&index=0&id=7036b02c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7036b02c",
  null
  
)

export default component.exports